import { render, staticRenderFns } from "./LifeCirqul.vue?vue&type=template&id=b8ce367c&scoped=true&"
import script from "./LifeCirqul.vue?vue&type=script&lang=js&"
export * from "./LifeCirqul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce367c",
  null
  
)

export default component.exports